import {useEffect} from 'react';

import {logProfilerTimingEvent} from 'performance/BenchlingProfiler';
import {ProfilerEvent} from 'performance/ProfilerConstants';
import usePrevious from 'ui-library/hooks/usePrevious';

/**
 * Hook to handle logging a `FINISHED` profiler event when a status changes from running to not running.
 */
export default function useLogAnalysisProfilerTimingFinished(
  isRunning: boolean,
  finishedEvents: Array<ProfilerEvent>
): void {
  const previousIsRunning = usePrevious(isRunning);

  useEffect(() => {
    if (previousIsRunning && !isRunning) {
      finishedEvents.forEach((finishedEvent) => {
        logProfilerTimingEvent(finishedEvent);
      });
    }
  }, [isRunning, previousIsRunning, finishedEvents]);
}
